<div class="w-full h-full flex flex-col">
  <app-lesson-header
    icon="bi-play-circle"
    iconColor="text-blue-500"
    [title]="lesson.title"
    [subtitle]="lesson.description"
  >
  </app-lesson-header>

  <div class="flex-1 min-h-0 overflow-y-auto p-6">
    <form
      [formGroup]="videoForm"
      (ngSubmit)="onSave()"
      class="flex flex-col gap-6 h-full"
    >
      <div class="space-y-4">
        <div>
          <label
            for="video-title"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Título da Lição *
          </label>
          <input
            type="text"
            id="video-title"
            formControlName="title"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('title')"
            placeholder="Digite o título da lição"
          />
          @if (isFieldInvalid('title')) {
          <p class="mt-1 text-sm text-red-600">{{ getFieldError('title') }}</p>
          }
        </div>

        <div>
          <label
            for="video-description"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Descrição *
          </label>
          <textarea
            id="video-description"
            formControlName="description"
            rows="4"
            class="form-field-textarea placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('description')"
            placeholder="Digite a descrição da lição"
          ></textarea>
          @if (isFieldInvalid('description')) {
          <p class="mt-1 text-sm text-red-600">
            {{ getFieldError('description') }}
          </p>
          }
        </div>

        <div>
          <label
            for="video-url"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            URL do Vídeo *
          </label>
          <input
            type="url"
            id="video-url"
            formControlName="videoUrl"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('videoUrl')"
            placeholder="https://www.youtube.com/embed/VIDEO_ID"
          />
          @if (isFieldInvalid('videoUrl')) {
          <p class="mt-1 text-sm text-red-600">
            {{ getFieldError('videoUrl') }}
          </p>
          }
          <p class="mt-1 text-xs text-blue-800">
            Use URL de embed do YouTube (ex:
            https://www.youtube.com/embed/VIDEO_ID)
          </p>
        </div>

        <div>
          <label
            for="video-duration"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Duração (minutos) *
          </label>
          <input
            type="number"
            id="video-duration"
            formControlName="duration"
            min="1"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('duration')"
            placeholder="0"
          />
          @if (isFieldInvalid('duration')) {
          <p class="mt-1 text-sm text-red-600">
            {{ getFieldError('duration') }}
          </p>
          }
        </div>
      </div>

      <div
        class="form-actions flex items-center justify-between border-t border-gray-200 pt-4"
      >
        <button type="button" class="btn-danger" (click)="onDelete()">
          <i class="bi bi-trash mr-2"></i>
          Excluir Lição
        </button>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="videoForm.invalid"
        >
          Salvar Alterações
        </button>
      </div>
    </form>
  </div>
</div>
